import React from 'react';
import { Typography, Box, CircularProgress, Paper } from '@mui/material';
import FactCard from './FactCard';
import { Fact } from '../../types';

interface FactListProps {
  facts: Fact[];
  emptyMessage?: string;
  loading?: boolean;
}

const FactList: React.FC<FactListProps> = ({
  facts,
  emptyMessage = '沒有可顯示的冷知識',
  loading = false,
}) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (facts.length === 0) {
    return (
      <Paper className="p-6 text-center">
        <Typography variant="body1" color="textSecondary">
          {emptyMessage}
        </Typography>
      </Paper>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', margin: -1.5 }}>
      {facts.map((fact) => (
        <Box
          key={fact.id}
          sx={{
            width: { xs: '100%', sm: '50%', md: '33.333%' },
            padding: 1.5,
          }}
        >
          <FactCard fact={fact} />
        </Box>
      ))}
    </Box>
  );
};

export default FactList;
